
import { Component, Vue } from "vue-property-decorator";
import ServicesNav from "@/components/Main/Services/ServicesNav.vue";
import ServicesBanner from "@/components/Main/Services/ServicesBanner.vue"
// import PublicPromocode from "@/components/Main/Services/PublicPromocode.vue";
import DexPNModal from "@/components/Main/Services/Modals/DexPNModal.vue" 
import ServiceOS from "@/components/Main/Services/ServiceOS.vue";
import GiftInfo from "@/components/Main/Services/GiftInfo.vue";
@Component({
  components: {
    ServicesNav,
    ServicesBanner,
    // PublicPromocode,
    ServiceOS,
    DexPNModal,
    GiftInfo
  },
})
export default class DexCloud extends Vue {
  public isShowModal: boolean  = false;

  // methods
  public handleShowModal() {
    this.isShowModal = true
  }

  public handleCloseDexPNModal() {
    this.isShowModal = false
  }
}
